import { URL_BASE_ESCALAMIENTO_ASIGNACION } from "../../constants/url";
import {
  composeErrorNotification,
  composeSuccessNotification,
} from "../../utils/composeNotification";
import { post } from "../../utils/fetch";
import { startLoadAsistencia } from "./detalleActions";
import { notification } from "./notificationActions";

export const startSetEscalamientoAsignacion = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ESCALAMIENTO_ASIGNACION}/SET/`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(
        notification(
          composeErrorNotification("Escalamiento", `${result.error}`)
        )
      );
    }
  };
};

//
export const startSetLiberacionEscalamientoAsignacion = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ESCALAMIENTO_ASIGNACION}/libera`;

    const result = await post(url, body);
    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID, false));
      dispatch(
        notification(
          composeSuccessNotification("Liberación exitosa", `${result.data}`)
        )
      );
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Liberar Escalamiento",
            `${result.error}`
          )
        )
      );
    }
  };
};

//
export const startSetTomaEscalamientoAsignacion = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ESCALAMIENTO_ASIGNACION}/SetTomaEscalamiento`;

    const result = await post(url, body);
    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID, false));
      dispatch(
        notification(
          composeSuccessNotification("Toma de asignamiento exitosa", `${result.data}`)
        )
      );
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Tomar Escalamiento",
            `${result.error}`
          )
        )
      );
    }
  };
};
